import { AbstractControl, FormArray, ValidationErrors, ValidatorFn } from "@angular/forms";
import { environment } from "src/environments/environment";


export function createIDsValidatorEstate(checkType: 'ID' | 'PIN' | 'TEL' | 'EMAIL', checkList: AbstractControl, altList: any[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control || !(checkList instanceof FormArray) || !Array.isArray(altList) || altList.length < 1) {
            return null;
        }

        const value = control.value;
        if (!value || value.length < 1) {
            return null;
        }

        const parent = control.parent;
        const index = parent ? checkList.controls.indexOf(parent) : -1;

        if (index === -1) {
            return null;
        }

        const valueExists = altList.some((alt, i) => {
            if (index >= altList.length - 1) {
                switch (checkType) {
                    case 'ID':
                        return alt.IDNo === value && index !== i;
                    case 'PIN':
                        return alt.KraPin === value && index !== i;
                    case 'TEL':
                        return alt.Phone === value && index !== i;
                    case 'EMAIL':
                        return alt.Email === value && index !== i;
                    default:
                        return false;
                }
            }
            return false;
        });

        return valueExists ? { exist: true } : null;
    };
}

export function createAmountAbove5KValidator(): ValidatorFn {
    return (control:AbstractControl) : ValidationErrors | null => {
        const value = control.value;

        let minAmount = 5000;
        
        if (!environment.production) minAmount = 1;

        if (!value || value.length < 6) {
            return null;
        }

        const numericValue = parseInt(value.replace(/\D/g,''));

        const isBelow5K: boolean = numericValue < minAmount;

        const valueValid = !isBelow5K;

        return !valueValid ? {cMin: true}: null;
    }
}

export function ageComparisonValidator(isCaps?: boolean): ValidatorFn {
  return (formGroup: AbstractControl): { [key: string]: any } | null => {
    let distributionAgeControl = formGroup.get('distributionAge');
    let terminationAgeControl = formGroup.get('terminationAge');

    if (isCaps) {
        distributionAgeControl = formGroup.get('DistributionAge');
        terminationAgeControl = formGroup.get('TerminationAge');
    }
    
    // Only validate if both fields have values
    if (distributionAgeControl && terminationAgeControl && 
        distributionAgeControl.value && terminationAgeControl.value) {
      
      const distributionAge = parseInt(distributionAgeControl.value);
      const terminationAge = parseInt(terminationAgeControl.value);
      
      if (terminationAge <= distributionAge) {
        // Set error on the termination age field
        terminationAgeControl.setErrors({ terminationAgeTooSmall: true });
        return { terminationAgeTooSmall: true };
      } else {
        // Clear the specific error (but keep any other errors)
        if (terminationAgeControl.errors) {
          const errors = { ...terminationAgeControl.errors };
          delete errors['terminationAgeTooSmall'];
          
          // If no errors remain, set to null, otherwise keep remaining errors
          terminationAgeControl.setErrors(Object.keys(errors).length ? errors : null);
        }
      }
    }
    
    return null;
  };
}
